exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-employers{position:absolute;right:0;margin-top:10px}.search-employers .user-disabled{position:absolute;top:-55px;cursor:pointer;color:#837d7d;border-bottom:1px solid #bdb3b3}.search-employers .user-disabled:hover{text-decoration:none}.search-employers label{display:block;font-weight:600;letter-spacing:100px}.search-employers input{display:inline-block;-webkit-border-radius:4px!important;-moz-border-radius:4px!important;border-radius:4px!important;width:50%}.search-employers button{background:#3598dc;color:#fff;text-decoration:none;margin-right:30px;border-radius:4px!important;border:none;font-weight:600;display:inline-block;height:33px;line-height:34px;margin-left:0;padding:0 14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fad0360","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/companyDetail/chanceDate.vue
// module id = 1148
// module chunks = 0